var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 2C3.23122 2 2 3.23122 2 4.75C2 6.26878 3.23122 7.5 4.75 7.5H6.4C7.00751 7.5 7.5 7.00751 7.5 6.4V4.75C7.5 3.23122 6.26878 2 4.75 2Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.5C3.23122 8.5 2 9.73122 2 11.25C2 12.7688 3.23122 14 4.75 14C6.26878 14 7.5 12.7688 7.5 11.25V9.6C7.5 8.99249 7.00751 8.5 6.4 8.5H4.75Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.75C8.5 3.23122 9.73122 2 11.25 2C12.7688 2 14 3.23122 14 4.75C14 6.26878 12.7688 7.5 11.25 7.5H9.6C8.99249 7.5 8.5 7.00751 8.5 6.4V4.75Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 8.5C8.99249 8.5 8.5 8.99249 8.5 9.6V11.25C8.5 12.7688 9.73122 14 11.25 14C12.7688 14 14 12.7688 14 11.25C14 9.73122 12.7688 8.5 11.25 8.5H9.6Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.75C2 3.23122 3.23122 2 4.75 2C6.26878 2 7.5 3.23122 7.5 4.75V6.4C7.5 7.00751 7.00751 7.5 6.4 7.5H4.75C3.23122 7.5 2 6.26878 2 4.75ZM6.5 4.75V6.4C6.5 6.45523 6.45523 6.5 6.4 6.5H4.75C3.7835 6.5 3 5.7165 3 4.75C3 3.7835 3.7835 3 4.75 3C5.7165 3 6.5 3.7835 6.5 4.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.25C2 9.73122 3.23122 8.5 4.75 8.5H6.4C7.00751 8.5 7.5 8.99249 7.5 9.6V11.25C7.5 12.7688 6.26878 14 4.75 14C3.23122 14 2 12.7688 2 11.25ZM4.75 9.5H6.4C6.45523 9.5 6.5 9.54477 6.5 9.6V11.25C6.5 12.2165 5.7165 13 4.75 13C3.7835 13 3 12.2165 3 11.25C3 10.2835 3.7835 9.5 4.75 9.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 2C9.73122 2 8.5 3.23122 8.5 4.75V6.4C8.5 7.00751 8.99249 7.5 9.6 7.5H11.25C12.7688 7.5 14 6.26878 14 4.75C14 3.23122 12.7688 2 11.25 2ZM9.6 6.5H11.25C12.2165 6.5 13 5.7165 13 4.75C13 3.7835 12.2165 3 11.25 3C10.2835 3 9.5 3.7835 9.5 4.75V6.4C9.5 6.45523 9.54477 6.5 9.6 6.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 9.6C8.5 8.99249 8.99249 8.5 9.6 8.5H11.25C12.7688 8.5 14 9.73122 14 11.25C14 12.7688 12.7688 14 11.25 14C9.73122 14 8.5 12.7688 8.5 11.25V9.6ZM9.6 9.5H11.25C12.2165 9.5 13 10.2835 13 11.25C13 12.2165 12.2165 13 11.25 13C10.2835 13 9.5 12.2165 9.5 11.25V9.6C9.5 9.54477 9.54477 9.5 9.6 9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qrCodeIcon.f4596ae0cbac8f5cf2efc67fa2d1c90a.svg";
export { ForwardRef as ReactComponent };